import { Component, Input, Output, EventEmitter } from "@angular/core";

export interface SidenavItem {
  label: string;
  icon?: string;
  route?: string;
  action?: () => void;
  children?: SidenavItem[];
  expanded?: boolean;
}

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.css"],
})
export class SidenavComponent {
  @Input() items: SidenavItem[] = [];
  @Input() opened = true;
  @Input() mode: "over" | "push" | "side" = "side";
  @Input() userName = "";
  @Input() companyLabel = "";
  @Input() showLogout = true;

  @Output() closedChange = new EventEmitter<void>();
  @Output() openedChange = new EventEmitter<boolean>();
  @Output() logout = new EventEmitter<void>();

  toggle(): void {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }

  onClose(): void {
    this.closedChange.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }

  toggleExpanded(item: SidenavItem): void {
    if (item.children && item.children.length > 0) {
      item.expanded = !item.expanded;
    }
  }

  handleItemClick(item: SidenavItem): void {
    if (item.action) {
      item.action();
    }
    this.toggleExpanded(item);
  }
}
